import type { Rules } from "@amzn/ads-feedback-kit";
import { RuleTarget, RuleType } from "@amzn/ads-feedback-kit";

export const AppCsatFeedbackFormRules: Rules = [
    {
        ruleTarget: RuleTarget.question,
        ruleType: RuleType.isRequired,
        questionId: "question_1",
        condition: () => true,
        conditionTrueMessage: "Provide your rating",
    },
    {
        ruleTarget: RuleTarget.question,
        ruleType: RuleType.isRequired,
        questionId: "question_2",
        condition: () => true,
        conditionTrueMessage: "Provide your feedback",
    },
];
